export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status?: number;
  detail: string | undefined;
  instance: string | undefined;
  extensions: Record<string, unknown>;
  errorCode: number;
}

/*
 * True if data is a ProblemDetails object (best guess)
 */
export function isProblemDetails(data: unknown): data is ProblemDetails {
  if (typeof data !== "object") return false;
  const record = data as Record<string, unknown>;
  return typeof data === "object" && "type" in record && "title" in record && "status" in record && "detail" in record;
}

/*
 * Returns data as ProblemDetails type, else undefined
 */
export function getProblemDetails(data: unknown): ProblemDetails | undefined {
  if (isProblemDetails(data)) {
    return data as ProblemDetails;
  }
  return undefined;
}

/*
 * Returns the error message from a ProblemDetails object, or message from an Error object, else undefined
 */
export const getProblemDetailsOrErrorObjectMessage = (data: unknown): string | undefined => {
  const problemDetails = getProblemDetails(data);
  if (problemDetails) {
    return problemDetails.detail || problemDetails.title;
  }
  if (data instanceof Error) {
    return data.message;
  }
  return undefined;
};
